import { useEffect } from "react";
import queryString from "query-string";
import Cookies from "universal-cookie";

const secondsInDay = 86400;

const getIsLocalhost = () => {
  return Boolean(
    window.location.hostname === "localhost" ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === "[::1]" ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
  );
};
/**
 * WARNING: The names of these two need to match exactly with the
 * cookies defined in the main application.
 */
const COOKIES = {
  REFERRAL_ID: "referralId",
  REFERRAL_TIME: "referralTime",
};

const useReferralCookie = () => {
  useEffect(() => {
    const search = queryString.parse(window?.location?.search);
    const referralId = search[COOKIES.REFERRAL_ID];

    if (!referralId) {
      return;
    }

    const cookies = new Cookies();
    const existingReferralId = cookies.get(COOKIES.REFERRAL_ID);

    if (existingReferralId) {
      return;
    }

    const isLocalhost = getIsLocalhost();

    const cookieOptions = {
      path: "/",
      domain: `${isLocalhost ? "" : "."}${window.location.hostname}`,
      maxAge: secondsInDay * 90,
    };

    cookies.set(COOKIES.REFERRAL_ID, referralId, cookieOptions);
    cookies.set(COOKIES.REFERRAL_TIME, new Date().toISOString(), cookieOptions);
  }, []);
};

export default useReferralCookie;
